<template>
  <div class="forgot-page">
  <div class="user-auth-container">
    <div class="auth-sky" aria-hidden="true"></div>
    <div class="auth-stars" aria-hidden="true"></div>
    <div class="auth-vignette" aria-hidden="true"></div>

    <div class="auth-wrap">
      <div class="auth-topbar">
        <div class="brand">
          <div class="brand-block"></div>
          <div class="brand-text">
            <div class="brand-title">云边小镇</div>
            <div class="brand-subtitle">FORGOT PASSWORD</div>
          </div>
        </div>
        <a class="back-home" href="/index">返回首页</a>
      </div>

      <div class="auth-card">
        <div class="title">找回密码</div>

        <div class="row">
          <label class="label">邮箱</label>
          <input class="mc-input" v-model.trim="email" @blur="validateEmail" @keyup.enter="submit" placeholder="请输入邮箱" />
          <div class="hint" v-if="emailHint">{{ emailHint }}</div>
        </div>

        <div class="row code-row">
          <div class="code-left">
            <label class="label">邮箱验证码</label>
            <input class="mc-input" v-model.trim="code" @keyup.enter="submit" placeholder="请输入邮箱验证码" />
          </div>
          <button class="mc-btn mc-btn-primary code-send" type="button" @click="sendCode" :disabled="sending || countdown > 0 || !email">
            {{ sending ? '发送中...' : countdown > 0 ? `${countdown}s` : '发送验证码' }}
          </button>
        </div>

        <div class="row">
          <label class="label">新密码（至少8位）</label>
          <input class="mc-input" v-model.trim="newPassword" @blur="validatePassword" type="password" @keyup.enter="submit" placeholder="请输入新密码" />
          <div class="hint" v-if="passwordHint">{{ passwordHint }}</div>
        </div>

        <div class="row">
          <label class="label">确认新密码</label>
          <input class="mc-input" v-model.trim="confirmPassword" @blur="validateConfirmPassword" type="password" @keyup.enter="submit" placeholder="请再次输入新密码" />
          <div class="hint" v-if="confirmPasswordHint">{{ confirmPasswordHint }}</div>
        </div>

        <div class="row" style="margin-top: 28px;">
          <button class="mc-btn mc-btn-primary" @click="submit" :disabled="loading">{{ loading ? '提交中...' : '重置密码' }}</button>
        </div>

        <div class="row actions">
          <a class="link" href="/login">返回登录</a>
          <a class="link" href="/register">注册</a>
        </div>

        <div v-if="error" class="error">{{ error }}</div>
        <div v-if="ok" class="ok">{{ ok }}</div>
      </div>

      <div class="auth-ground" aria-hidden="true">
        <div class="grass"></div>
        <div class="dirt"></div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue'

import { API_BASE } from '../config/apiBase'

// API_BASE moved to @/config/apiBase


export default {
  name: 'ForgotPage',
  setup() {
    const email = ref('')
    const code = ref('')
    const newPassword = ref('')
    const confirmPassword = ref('')


    const emailHint = ref('')
    const passwordHint = ref('')
    const confirmPasswordHint = ref('')

    const error = ref('')
    const ok = ref('')
    const loading = ref(false)

    const sending = ref(false)
    const countdown = ref(0)
    let timer = null

    const isEmail = (v) => /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(v || '')

    const validateEmail = () => {
      if (!email.value) {
        emailHint.value = '请输入邮箱'
        return false
      }
      if (!isEmail(email.value)) {
        emailHint.value = '邮箱格式不正确'
        return false
      }
      emailHint.value = ''
      return true
    }

    const validatePassword = () => {
      if (!newPassword.value) {
        passwordHint.value = '请输入新密码'
        return false
      }
      if (newPassword.value.length < 8) {
        passwordHint.value = '密码至少8位'
        return false
      }
      passwordHint.value = ''
      return true
    }

    const validateConfirmPassword = () => {
      if (!confirmPassword.value) {
        confirmPasswordHint.value = '请再次输入新密码'
        return false
      }
      if (confirmPassword.value !== newPassword.value) {
        confirmPasswordHint.value = '两次输入的密码不一致'
        return false
      }
      confirmPasswordHint.value = ''
      return true
    }


    const startCountdown = () => {
      countdown.value = 60
      if (timer) clearInterval(timer)
      timer = setInterval(() => {
        countdown.value -= 1
        if (countdown.value <= 0) {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    }

    const sendCode = async () => {
      error.value = ''
      ok.value = ''
      if (!validateEmail()) return
      if (countdown.value > 0) return
      sending.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/sendEmailCode`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email.value, scene: 'forgot' })
        })
        const data = await res.json()
        if (data && data.code === 200) {
          startCountdown()
          ok.value = '验证码已发送，请查收邮箱'
        } else {
          error.value = (data && data.message) || '发送失败'
        }
      } catch (e) {
        error.value = '发送失败'
      } finally {
        sending.value = false
      }
    }

    const submit = async () => {
      error.value = ''
      ok.value = ''
      const v1 = validateEmail()
      const v2 = validatePassword()
      const v3 = validateConfirmPassword()
      if (!v1 || !v2 || !v3) return
      if (!code.value) {
        error.value = '请输入邮箱验证码'
        return
      }
      loading.value = true
      try {
        const res = await fetch(`${API_BASE}/user-auth/forgot`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email.value,
            code: code.value,
            newPassword: newPassword.value,
            confirmPassword: confirmPassword.value,
            

          })
        })
        const data = await res.json()
        if (data && data.code === 200) {
          ok.value = data.message || '密码修改成功'
        } else {
          error.value = (data && data.message) || '操作失败'
        }
      } catch (e) {
        error.value = '操作失败'
      } finally {
        loading.value = false
      }
    }


    onUnmounted(() => {
      if (timer) clearInterval(timer)
    })

    return {
      email,
      code,
      newPassword,
      confirmPassword,
      emailHint,
      passwordHint,
      confirmPasswordHint,
      error,
      ok,
      loading,
      sending,
      countdown,
      validateEmail,
      validatePassword,
      validateConfirmPassword,
      sendCode,
      submit
    }
  }
}
</script>

<style>
@import '../styles/auth-mc.css';

/* 忘记密码页卡片化布局 - 仅影响本页面 */
.forgot-page .user-auth-container {
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 100vh;
}

.forgot-page .auth-wrap {
  width: 100%;
  max-width: 680px;
  min-height: auto;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.forgot-page .auth-topbar {
  display: none;
}

.forgot-page .auth-card {
  background: rgba(0, 0, 0, 0.94);
  border: 8px solid #5a5a5a;
  border-radius: 12px;
  padding: 60px 50px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.9), inset 0 0 0 2px rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.forgot-page .auth-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 8px;
  background: linear-gradient(90deg, var(--mc-green) 0%, #9ae054 50%, var(--mc-green) 100%);
  border-bottom: 3px solid #3c6b10;
}

.forgot-page .auth-card::after {
  content: '';
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
}

.forgot-page .auth-ground {
  display: none;
}

.forgot-page .title {
  text-align: center;
  font-size: 30px;
  color: #fff;
  text-shadow: 5px 5px 0 #000;
  margin-bottom: 36px;
  letter-spacing: 2px;
}

/* 主按钮：居中拉长，适配卡片 */
.forgot-page .auth-card .mc-btn.mc-btn-primary {
  display: block;
  width: min(420px, 100%);
  margin: 0 auto;
  padding: 14px 18px;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 2px;
}

/* 邮箱验证码发送按钮：保持在右侧，不被“主按钮”样式影响 */
.forgot-page .auth-card .mc-btn.mc-btn-primary.code-send {
  width: auto;
  margin: 0;
  padding: 12px 16px;
  font-size: 12px;
  letter-spacing: 1px;
}

/* 操作链接 */
.forgot-page .actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid rgba(255,255,255,0.1);
}

.forgot-page .link {
  color: var(--mc-green);
  text-decoration: none;
  font-size: 14px;
  font-weight: 800;
  padding: 6px 10px;
  transition: color 0.2s ease;
}

.forgot-page .link:hover {
  color: #9ae054;
}

/* 错误/成功提示 */
.forgot-page .error {
  background: rgba(231, 76, 60, 0.1);
  border: 2px solid #e74c3c;
  color: #e74c3c;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

.forgot-page .ok {
  background: rgba(154, 224, 84, 0.1);
  border: 2px solid #9ae054;
  color: #9ae054;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 16px;
  text-align: center;
}

/* 响应式 */
@media (max-width: 480px) {
  .forgot-page .user-auth-container {
    padding: 10px;
  }

  .forgot-page .auth-card {
    padding: 30px 20px;
  }

  .forgot-page .title {
    font-size: 20px;
  }

  .forgot-page .actions {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
}
</style>

